var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "users-members-tab dashboard-tab" }, [
    _c("div", { staticClass: "va-row" }, [
      _c(
        "div",
        { staticClass: "flex md3 flex justify--center align--center" },
        [
          _c("vuestic-profile-card", {
            attrs: {
              name: "Veronique Lee",
              location: "Malaga, Spain",
              photoSource: "https://i.imgur.com/NLrdqsk.png",
              social: {
                twitter: "twitter.com",
                facebook: "facebook.com",
                instagram: "instagram.com",
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex md9" },
        [
          _c("vuestic-chat", {
            model: {
              value: _vm.chatMessages,
              callback: function ($$v) {
                _vm.chatMessages = $$v
              },
              expression: "chatMessages",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }